import { useCallback, useState } from 'react';

type UseSnackbarReturn = {
  errorText: string;
  infoText: string;
  snackbarOpen: boolean;
  setErrorText: (text: string) => void;
  setInfoText: (text: string) => void;
  setSnackbarOpen: (open: boolean) => void;
};

// infoTextとerrorTextが重複しないように、一方を設定したらもう一方をクリアする
// setter は useCallback で安定参照にしておく（呼び出し側が useEffect/useCallback の依存配列に
// 入れても無限ループにならないように）
const useSnackbar = (): UseSnackbarReturn => {
  const [errorText, setErrorTextState] = useState<string>('');
  const [infoText, setInfoTextState] = useState<string>('');
  const [snackbarOpen, setSnackbarOpenState] = useState<boolean>(false);

  const setSnackbarOpen = useCallback((open: boolean): void => {
    setSnackbarOpenState(open);
    if (!open) {
      setErrorTextState('');
      setInfoTextState('');
    }
  }, []);

  const setInfoText = useCallback((text: string): void => {
    setInfoTextState(text);
    if (text) {
      setErrorTextState('');
    }
  }, []);

  const setErrorText = useCallback((text: string): void => {
    setErrorTextState(text);
    if (text) {
      setInfoTextState('');
    }
  }, []);

  return {
    errorText,
    infoText,
    snackbarOpen,
    setErrorText,
    setInfoText,
    setSnackbarOpen,
  };
};

export default useSnackbar;
